<template>
    <el-dropdown @command="handleClick" class="lang-seletor">
        <i class="auth-icon-lang dropdown-img" style="margin:0;"></i>
        <el-dropdown-menu slot="dropdown">
            <el-dropdown-item v-for="item in langList" :key="item.value" :command="item">
                {{item.name}}
            </el-dropdown-item>
        </el-dropdown-menu>
    </el-dropdown>
</template>
<script>
import { I18nMixins } from '@/components/utils/i18n';

export default {
    name: 'Lang',
    mixins: [I18nMixins],
    data() {
        // 语言编码参考 https://www.cnblogs.com/jacksoft/p/5771130.html
        return {
            langList: [
                {
                    name: '中文-简体',
                    value: 'zh-CN'
                },
                {
                    name: 'English',
                    value: 'en-US'
                }
            ]
        };
    },
    methods: {
        handleClick(item) {
            const langCode = item.value;
            localStorage.setItem('lang', langCode);
            this.$router.go(0);
        }
    }
};
</script>
<style lang="less">
.lang-seletor {
    cursor: pointer;
    margin-right: 20px;
    .dropdown-img{
        font-size: 20px;
        margin-right: 8px;
        vertical-align: middle;
        &.auth-icon-message {
            display: block;
        }
    }
    .el-badge__content.is-fixed {
        right: 17px;
    }
}
</style>
